module.exports = __webpack_public_path__ + "static/media/direct-buy.348674ee.svg";